
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...categoryOrProductPage]",
      function () {
        return require("private-next-pages/[...categoryOrProductPage].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...categoryOrProductPage]"])
      });
    }
  